'use client';

import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';

import { PagingProps } from '@/shared/types/pagingTypes';

const Paging = ({ setCurrentPage, currentPage, totalPage }: PagingProps) => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ReactPaginate
      pageCount={totalPage}
      pageRangeDisplayed={5}
      marginPagesDisplayed={windowWidth < 768 ? 1 : 2}
      previousLabel="<"
      nextLabel=">"
      containerClassName="flex w-full justify-center pagination"
      pageClassName="mr-3"
      pageLinkClassName="px-1.5 py-0.5 text-xs text-gray-700 rounded-full"
      activeLinkClassName="bg-[#8F689A] rounded-full text-white"
      previousClassName="mr-3"
      previousLinkClassName="px-1.5 py-0.5 text-xs text-gray-700 rounded-full"
      nextClassName="mr-3"
      nextLinkClassName="px-1.5 py-0.5 text-xs text-gray-700 rounded-full"
      breakClassName="mx-5"
      breakLinkClassName="text-gray-500"
      onPageChange={({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      forcePage={currentPage - 1}
      ariaLabelBuilder={(page) => `Go to page ${page}`}
    />
  );
};

export default Paging;
